import { useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import tickCircleIcon from 'assets/images/playroompage-tickCircle.svg'

function SelectAva({ defaultAva }) {
	const { t } = useTranslation()

	let isSelectAva = false
	const [selectedAva, setSelectedAva] = useState(null)
	function handleSelectAva(avaId) {
		setSelectedAva(avaId)
	}
	console.log(defaultAva, 'defaultAva')
	return (
		<>
			<Row className="profilepage-content__title">
				{t('profile.select_ava')}
			</Row>
			<Row className="profilepage-content__body selectava-avastack row-cols-5 my-3">
				{defaultAva?.map(item => {
					isSelectAva = selectedAva === item?.id
					return (
						<Col
							key={item?.id}
							className={`selectava-avastack-img 
							${isSelectAva ? 'is-selected' : ''}`}
						>
							<img
								src={item?.image}
								className="ava"
								onClick={() => handleSelectAva(item?.id)}
								alt="Default avatar"
							/>
							{selectedAva && item?.id === selectedAva ? (
								<img
									src={tickCircleIcon}
									className="current"
									alt="Current avatar"
								/>
							) : null}
						</Col>
					)
				})}
			</Row>
			<Button className="profile-confirm" disabled={!selectedAva}>
				{t('confirm')}
			</Button>
		</>
	)
}

export default SelectAva
